<template>
  <div>
    <div class="vx-card__body card-body">
      <receipt-image-popup
        :show="isShowReceiptImagePopup"
        :PackagereceiptImageInfo="PackagereceiptImageInfo"
        @finish="onfinish"
      ></receipt-image-popup>
      <div class="flex">
        <div class="w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('PackageId') },
              { title: $t('CreateOn') },
              { title: $t('PackageInfo') },
              { title: $t('ReceiptDelivered') }
            ]"
          >
            <template slot-scope="{ row }">
              <td style="width: 20%">{{ row.id }}</td>
              <td style="width: 30%;direction: ltr;">
                {{ row.createOn.split(" ")[0] }}<br />{{
                  row.createOn.split(" ")[1]
                }}
              </td>
              <td style="width: 20%">
                <router-link
                  :to="{
                    path: '/Package/Details/0/' + row.id,
                    query: {
                      breadcrumbNameManual: {
                        persianTitle: 'عملیات اپراتور',
                        Title: 'OperationOperators'
                      }
                    }
                  }"
                >
                  <vs-button
                    radius
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-eye"
                    class="mx-4 d-inline"
                  ></vs-button>
                </router-link>
              </td>
              <td style="width: 20%">
                <vs-button
                  radius
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-eye"
                  class="mx-4 d-inline"
                  @click.prevent="showReceiptImagePopup(row)"
                ></vs-button>
              </td>
            </template>
          </data-grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ReceiptImagePopup from "../../Details_Package1/ReceiptImagePopup.vue";

export default {
  name: "shipping-OperationOperators-delivered",
  components: {
    DataGrid,
    ReceiptImagePopup
  },
  data() {
    return {
      isShowReceiptImagePopup: false,
      gridDataSource: {
        type: "app",
        service: "Shipping/api/PackagesQuery/by-logged-in-operator"
      },
      gridSearchData: {
        packageStateType: 3
      },
      PackagereceiptImageInfo: ""
    };
  },

  methods: {
    showReceiptImagePopup(PackageInfo) {
      this.isShowReceiptImagePopup = true;
      this.PackagereceiptImageInfo = PackageInfo.receiptImage;
    },
    onfinish() {
      this.isShowReceiptImagePopup = false;
    }
  }
};
</script>
